// extracted by mini-css-extract-plugin
export default {"faktaboks":"koranskolene-v0-faktaboks-xL2p8","expanded":"koranskolene-v0-expanded-GwlKF"};